<template>
  <section id="screening-list" v-if="dataset.length > 0">
     <div
      v-for="(group, i) in dataset"
      :key="i"
      class="screening-group"
      >
      <div class="screening-group-title" :class="{'sticky': stickyTitle}">
        {{titleFunction(group)}}
      </div>
      <screenings-list-item
        v-for="(screening, j) in group.screenings" :key="j"
        :screening="screening"
        :facilities="facilities"
        @onRowClicked="$emit('onRowClicked', screening)"
        @editScreeningPerson="$emit('editScreeningPerson', screening)"
        @sendQRCode="$emit('sendQRCode', screening)"
        @openLeadsListing="$emit('openLeadsListing', screening)"
        @openAppointments="$emit('openAppointments', screening)"
        @updateScreening="$emit('updateScreening', screening)"
        @openSessionReport="$emit('showSessionReport', screening)"
        @generateSessionReport="$emit('generateSessionReport', screening)"
      >
      </screenings-list-item>
    </div>
  </section>
</template>

<script>
import ScreeningsListItem from './ScreeningsListItem'
export default {
  props: {
    data: {
      type: Array,
      required: false
    },
    groupFunction: {
      type: Function,
      required: true
    },
    titleFunction: {
      type: Function,
      required: true
    },
    stickyTitle: {
      type: Boolean,
      required: false,
      default: false
    },
    facilities: {
      type: Array,
      required: true
    },
  },
  components: {
    ScreeningsListItem
  },
  computed: {
    dataset: function () {
      if (Array.isArray(this.data) && this.data.length > 0) {
        return this.groupFunction(this.data)
      } else {
        return []
      }
    }
  }
}
</script>

<style lang="scss" scoped>

  .screening-group {
    /* border: solid 1px #ddd; */
    border-radius: 0.2em;
    border-left: 0px;
    border-right: 0px;
    margin-bottom: 1.25em;

    cursor: pointer;

    .screening-group-title {
      padding: 0.5em 1.25em 0.5em 1.25em;
      background: #eee;
      font-weight: bold;
      border-radius: 0.2em;

      &.sticky {
        position: -webkit-sticky;
        position: sticky;
        top: 0px;
        z-index: 10;
      }
    }
  }
</style>
